import { useEffect, useState } from "react";
import { Shield, ArrowUp, Download } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

const Etica = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 400);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className="min-h-screen bg-background">
          <SEO
            title="Código de Conduta e Ética"
            description="Código de Conduta e Ética da Aroan: princípios, responsabilidades e canais de denúncia que orientam nossa relação com clientes, parceiros e colaboradores."
            canonical="https://aroan.com.br/etica"
            ogType="website"
            article={false}
          />
            <Header />

            <main className="pt-24 pb-20">
                <section className="py-16 bg-gradient-to-br from-primary/10 via-background to-background border-b border-border">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="max-w-4xl mx-auto text-center">
                            <h1 className="text-4xl sm:text-5xl font-bold mb-6">
                                Código de <span className="text-primary">Conduta e Ética</span>
                            </h1>
                            <p className="text-lg text-muted-foreground">
                                Diretrizes para manter elevados padrões de ética e integridade.
                            </p>
                        </div>
                    </div>
                </section>

                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="max-w-4xl mx-auto space-y-12">

                        <section>
                            <div className="flex items-start gap-4 mb-6">
                                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                                    <Shield className="w-6 h-6 text-primary" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold mb-4">Compromisso com a Integridade</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        O Código de Conduta e Ética do Vertice Aroan estabelece as diretrizes para manter elevados padrões de ética e integridade no ambiente de trabalho, orientando todas as relações profissionais e pessoais dentro da empresa. O Vertice Aroan se compromete a combater práticas como discriminação, assédio, corrupção e suborno, prezando pela transparência e pelo respeito em todas as interações.
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="pl-16">
                                <p className="text-muted-foreground leading-relaxed">
                                    O código se aplica a todos os colaboradores, fornecedores e prestadores de serviços, independentemente da hierarquia, e tem como objetivos principais promover uma cultura de honestidade, respeito mútuo e desenvolvimento contínuo. A empresa espera que todos cumpram com as leis, sejam éticos nas suas ações e relatem comportamentos inadequados.
                                </p>
                            </div>
                        </section>

                        <section>
                            <div className="pl-16">
                                <p className="text-muted-foreground leading-relaxed">
                                    O Vertice Aroan valoriza a diversidade, a igualdade de oportunidades e a inclusão, além de buscar constantemente a excelência nos serviços prestados. A ética é a base de todas as suas operações, sendo intolerante a práticas fraudulentas e corrupções. A empresa também oferece um canal confidencial para denúncias de irregularidades, assegurando proteção e anonimato para quem se pronunciar contra condutas impróprias.
                                </p>
                            </div>
                        </section>

                        <section className="pl-16 pt-4">
                            <Button asChild className="gap-2">
                                <a href="/arquivos_publicos/1.0-Codigo-de-Etica-da-Vertice-Aroan.pdf" download target="_blank" rel="noopener noreferrer">
                                    <Download className="w-4 h-4" />
                                    Baixar Código de Ética (PDF)
                                </a>
                            </Button>
                        </section>

                    </div>
                </div>
            </main>

            {showScrollTop && (
                <Button
                    onClick={scrollToTop}
                    size="icon"
                    className="fixed bottom-8 right-8 z-50 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in"
                    aria-label="Voltar ao topo"
                >
                    <ArrowUp className="h-5 w-5" />
                </Button>
            )}

            <Footer />
        </div>
    );
};

export default Etica;
